export default __webpack_public_path__ + "ec0438eb07aca3e9e6c70f5f830b9388.png";